import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Onefourseatertempotraveller() {



    const cardData = {

keyword: "14 Seater Tempo Traveller on Rent",

headingDescription:
    "Rising Cab Service offers safe, comfortable, and reliable 14 Seater Tempo Traveller on Rent for group travel, family tours, corporate outings, weddings, school trips, and outstation journeys. Our well-maintained 14-seater Tempo Travellers come with push-back seats, air conditioning, spacious legroom, and experienced drivers for smooth highway travel. With doorstep pickup from Pune, flexible rental options, 24/7 support, and transparent pricing, we ensure a comfortable and hassle-free travel experience for medium-sized groups across all destinations.",

topPlaces: [
    
    {
        title: "Mahabaleshwar Hill Station",
        description:
            "Mahabaleshwar is a famous hill station known for strawberry farms, viewpoints, and cool climate. It is ideal for medium group travel, offering comfortable journeys for families, friends, and corporate teams exploring nature, sightseeing spots, and relaxing hill experiences."
    },
    {
        title: "Shirdi Sai Baba Darshan",
        description:
            "Shirdi is one of the most important pilgrimage destinations in Maharashtra dedicated to Sai Baba. A 14-seater Tempo Traveller is perfect for group darshan tours, ensuring families and devotees travel together comfortably for spiritual visits and blessings."
    },
    {
        title: "Nashik & Trimbakeshwar",
        description:
            "Nashik is a spiritual and cultural destination known for Trimbakeshwar Jyotirlinga, Panchavati temples, and vineyards. It is a popular group travel location for religious tours, family trips, and leisure outings using 14-seater Tempo Traveller rentals from Pune."
    },
    {
        title: "Goa Beach Tour",
        description:
            "Goa is a long-distance vacation destination famous for beaches, nightlife, and adventure activities. A 14-seater Tempo Traveller is ideal for friends, families, and corporate groups traveling together for a comfortable and enjoyable beach holiday."
    },
    {
        title: "Ashtavinayak Darshan Route",
        description:
            "The Ashtavinayak pilgrimage circuit includes eight sacred Ganpati temples across Maharashtra. A 14-seater Tempo Traveller is widely used for group spiritual tours, providing comfort and coordination for family religious journeys from Pune."
    },
    {
        title: "Bhimashankar Jyotirlinga",
        description:
            "Bhimashankar is a sacred Jyotirlinga temple located in the Sahyadri hills surrounded by dense forest. It is a popular pilgrimage destination where a 14-seater Tempo Traveller ensures safe and comfortable travel for devotees and families."
    },
    {
        title: "Lonavala & Khandala",
        description:
            "Lonavala and Khandala are the most popular short trip destinations near Pune, known for lush green valleys, waterfalls, foggy mountains, and scenic viewpoints. A 14-seater Tempo Traveller is perfect for family groups and corporate outings to enjoy monsoon drives and weekend relaxation together."
    },
    {
        title: "Alibaug Beaches",
        description:
            "Alibaug is a coastal destination near Mumbai known for beaches, forts, and water sports. It is ideal for group outings, family picnics, and corporate trips using 14-seater Tempo Traveller rentals from Pune for a smooth coastal journey."
    },
    {
        title: "Aurangabad Heritage Circuit",
        description:
            "Aurangabad is famous for Ajanta and Ellora Caves, UNESCO World Heritage Sites. It is a top destination for group heritage tours, educational trips, and cultural travel using 14-seater Tempo Traveller from Pune."
    },
    {
        title: "Konkan Coastal Trip",
        description:
            "The Konkan coast including Ganpatipule, Diveagar, Harihareshwar, and Tarkarli is a scenic travel region. A 14-seater Tempo Traveller is perfect for long group vacations, offering comfort and space for beach tours from Pune."
    }
],



services: [
{
name: "14 Seater Bus on Rent in Pune",
description: "Rising Cab Service offers 14 Seater Bus on Rent in Pune for family trips, corporate travel, weddings, and group tours. Our well-maintained AC and non-AC buses come with experienced drivers, comfortable seating, and smooth suspension for long-distance and city travel. Enjoy safe, reliable, and affordable group transportation with doorstep pickup and flexible booking options across Pune and nearby locations."
},
{
name: "14 Seater Tempo Traveller on Rent Pimpri Chinchwad",
description: "Book 14 Seater Tempo Traveller on Rent in Pimpri Chinchwad with Rising Cab Service for outstation trips, corporate travel, and family tours. Our vehicles are equipped with push-back seats, luggage space, and professional chauffeurs ensuring a comfortable journey. Ideal for weekend getaways, weddings, and pilgrimage trips with flexible pricing and 24x7 availability."
},
{
name: "Hire 14 Seater Minibus for Picnic",
description: "Rising Cab Service provides Hire 14 Seater Minibus for Picnic options designed for school trips, office outings, and family picnic plans. Enjoy spacious seating, safe driving, and well-maintained vehicles suitable for hill stations and resorts. Our minibuses ensure a smooth and enjoyable group travel experience with customized pickup and drop services."
},
{
name: "14 Seater Bus Rental in Pune",
description: "Our 14 Seater Bus Rental in Pune service is perfect for corporate events, wedding functions, and outstation tours. We offer clean vehicles, experienced drivers, and flexible rental plans based on distance and duration. Travel comfortably with your group while we take care of safety, route planning, and timely service."
},
{
name: "13 Seater Bus Hire in Pune",
description: "Book 13 Seater Bus Hire in Pune for small group travel, airport transfers, and short trips. Our buses are well-maintained with comfortable seating and professional drivers ensuring safe and timely travel. Ideal for family outings, corporate pickups, and local sightseeing tours."
},
{
name: "14 Seater Mini Bus Rental for Corporate",
description: "Rising Cab Service offers 14 Seater Mini Bus Rental for Corporate travel, staff transportation, and business events. Enjoy punctual service, clean interiors, and experienced drivers for smooth office commutes and corporate tours. We ensure reliable and professional transport solutions for companies in Pune."
},
{
name: "14 Seater Tempo Traveller Per Km Rate in Pune",
description: "Get transparent 14 Seater Tempo Traveller per Km Rate in Pune with no hidden charges. Our pricing is budget-friendly and ideal for outstation trips, weddings, and group tours. We offer flexible packages depending on distance, duration, and travel type with well-maintained AC vehicles."
},
{
name: "14 Seater AC Bus Rental for Picnic",
description: "Book 14 Seater AC Bus Rental for Picnic with Rising Cab Service for safe and comfortable group outings. Enjoy chilled air-conditioning, spacious seating, and smooth rides to Lonavala, Mahabaleshwar, or nearby picnic destinations. Perfect for family and corporate leisure trips."
},
{
name: "13 Seater Non AC Bus on Rent",
description: "Our 13 Seater Non AC Bus on Rent service is ideal for budget-friendly group travel. Suitable for short-distance trips, rural travel, and local tours, our buses are clean, safe, and driven by experienced chauffeurs ensuring smooth transportation."
},
{
name: "Pune to Goa 14 Seater AC Bus Rental",
description: "Rising Cab Service provides Pune to Goa 14 Seater AC Bus Rental for comfortable long-distance beach trips. Enjoy luxury seating, luggage space, and professional drivers for a safe and enjoyable journey to Goa with your group or family."
},
{
name: "Pune to Mahabaleshwar 14 Seater Tempo Traveller",
description: "Book Pune to Mahabaleshwar 14 Seater Tempo Traveller for a relaxing hill station trip. Our vehicles ensure smooth travel on ghats with experienced drivers, comfortable seating, and flexible stops for sightseeing and photography."
},
{
name: "Pune to Shirdi 14 Seater Bus on Rent",
description: "Our Pune to Shirdi 14 Seater Bus on Rent service is perfect for pilgrimage groups visiting Sai Baba temple. We offer safe, comfortable, and timely travel with AC vehicles and experienced drivers for a peaceful darshan journey."
},
{
name: "Pune Airport to Lonavala Tempo Traveller on Rent",
description: "Rising Cab Service offers Pune Airport to Lonavala Tempo Traveller on Rent for instant group transfers. Enjoy smooth pickup from the airport and comfortable travel to Lonavala with spacious seating and professional drivers."
},
{
name: "Pune Airport to Shirdi Tempo Traveller on Rent",
description: "Book Pune Airport to Shirdi Tempo Traveller on Rent for hassle-free pilgrimage travel. Our service ensures timely airport pickup, clean vehicles, and comfortable journey to Shirdi with complete travel support."
},
{
name: "14 Seater Tempo Traveller Rate Per Km in Pune",
description: "Get the best 14 Seater Tempo Traveller Rate Per Km in Pune with affordable pricing and transparent billing. Suitable for outstation tours, weddings, and group travel with AC comfort and experienced drivers."
},
{
name: "14 Seater Tempo Traveller Hire in Pimpri Chinchwad",
description: "We provide 14 Seater Tempo Traveller Hire in Pimpri Chinchwad for local and outstation travel needs. Our service includes clean vehicles, professional chauffeurs, and flexible booking options for families and corporate groups."
},
{
name: "14 Seater Tempo Traveller on Rent",
description: "Book 14 Seater Tempo Traveller on Rent for all types of group travel including tours, weddings, and corporate trips. Enjoy comfort, safety, and reliable service with well-maintained AC vehicles and experienced drivers."
},
{
name: "14 Seater Tempo Traveller Hire",
description: "Rising Cab Service offers 14 Seater Tempo Traveller Hire for short and long-distance journeys. Perfect for group travel with spacious seating, luggage space, and professional drivers ensuring smooth rides."
},
{
name: "14 Seater Tempo Traveller Booking",
description: "Easily complete 14 Seater Tempo Traveller Booking with Rising Cab Service for instant confirmation. We offer flexible packages, transparent pricing, and 24x7 customer support for all travel needs."
},
{
name: "14 Seater Tempo Traveller Rentals",
description: "Our 14 Seater Tempo Traveller Rentals service provides comfortable and safe group transportation for outstation trips, weddings, and events. Enjoy clean interiors, AC comfort, and reliable travel support across Maharashtra."
}
],

tableData: [
["14 Seater Bus on Rent in Pune","14 Seater Tempo Traveller on Rent Pimpri Chinchwad"],
["Hire 14 Seater Minibus for Picnic","14 Seater Bus Rental in Pune"],
["13 Seater Bus Hire in Pune","14 Seater Mini Bus Rental for Corporate"],
["14 Seater Tempo Traveller Per Km Rate in Pune","14 Seater AC Bus Rental for Picnic"],
["13 Seater Non AC Bus on Rent","Pune to Goa 14 Seater AC Bus Rental"],
["Pune to Mahabaleshwar 14 Seater Tempo Traveller","Pune to Shirdi 14 Seater Bus on Rent"],
["Pune Airport to Lonavala Tempo Traveller on Rent","Pune Airport to Shirdi Tempo Traveller on Rent"],
["14 Seater Tempo Traveller Rate Per Km in Pune","14 Seater Tempo Traveller Hire in Pimpri Chinchwad"],
["14 Seater Tempo Traveller on Rent","14 Seater Tempo Traveller Hire"],
["14 Seater Tempo Traveller Booking","14 Seater Tempo Traveller Rentals"]
],



whychoose: [
    {
        WhyChooseheading: "Comfortable 14 Seater Tempo Traveller on Rent",
        WhyChoosedescription: "Rising Cab Service provides spacious 14 Seater Tempo Traveller rentals for family trips, corporate outings, pilgrimages, sightseeing tours, weddings, and group travel."
    },
    {
        WhyChooseheading: "Perfect for Small and Medium Groups",
        WhyChoosedescription: "The 14 Seater Tempo Traveller is an ideal choice for families, friends, office teams, school groups, and tourists traveling together comfortably."
    },
    {
        WhyChooseheading: "Suitable for Local and Outstation Travel",
        WhyChoosedescription: "Our Tempo Travellers are available for Pune local travel as well as outstation destinations including Mahabaleshwar, Goa, Shirdi, Nashik, Konkan, Kolhapur, and Lonavala."
    },
    {
        WhyChooseheading: "Spacious Seating and Ample Luggage Space",
        WhyChoosedescription: "Passengers enjoy comfortable seating arrangements, sufficient legroom, luggage space, and a pleasant travel experience throughout the journey."
    },
    {
        WhyChooseheading: "Air-Conditioned Tempo Traveller Available",
        WhyChoosedescription: "Well-maintained AC Tempo Travellers ensure comfortable travel during long-distance journeys, sightseeing tours, and summer vacations."
    },
    {
        WhyChooseheading: "Pickup Available Across Pune & PCMC",
        WhyChoosedescription: "Tempo Traveller pickup services are available from Baner, Wakad, Hinjewadi, Kharadi, Hadapsar, Viman Nagar, Kothrud, Pimpri Chinchwad, Wagholi, and nearby locations."
    },
    {
        WhyChooseheading: "Professional Drivers for Safe Travel",
        WhyChoosedescription: "Experienced drivers ensure safe driving, punctual reporting, smooth highway travel, and professional service throughout the trip."
    },
    {
        WhyChooseheading: "Best Choice for Tours and Group Events",
        WhyChoosedescription: "The 14 Seater Tempo Traveller is widely preferred for religious tours, family vacations, corporate events, destination weddings, and weekend getaways."
    }
]
};

const faqData = [
    {
        question: "What is a 14 Seater Tempo Traveller?",
        answer: "A 14 Seater Tempo Traveller is a spacious passenger vehicle designed for comfortable group travel with seating for up to 14 passengers."
    },
    {
        question: "Can I hire a 14 Seater Tempo Traveller for outstation trips?",
        answer: "Yes, Tempo Travellers are available for outstation destinations across Maharashtra and other states."
    },
    {
        question: "Is AC available in the 14 Seater Tempo Traveller?",
        answer: "Yes, air-conditioned Tempo Travellers are available for comfortable travel."
    },
    {
        question: "Can families hire a 14 Seater Tempo Traveller for vacations?",
        answer: "Yes, it is one of the most popular choices for family holidays, sightseeing tours, and weekend trips."
    },
    {
        question: "Do you provide Tempo Travellers for pilgrimage tours?",
        answer: "Yes, vehicles are available for Shirdi, Ashtavinayak, Pandharpur, Tuljapur, Akkalkot, Jyotirlinga, and other religious tours."
    },
    {
        question: "Can corporate groups rent a 14 Seater Tempo Traveller?",
        answer: "Yes, corporate teams frequently hire Tempo Travellers for employee outings, conferences, meetings, and events."
    },
    {
        question: "Is luggage space available in the vehicle?",
        answer: "Yes, the Tempo Traveller offers sufficient luggage space for passengers during long-distance journeys."
    },
    {
        question: "Can I book a Tempo Traveller for wedding transportation?",
        answer: "Yes, Tempo Travellers are commonly hired for wedding guest transportation and family events."
    },
    {
        question: "Do you provide pickup from Pune Airport and Railway Station?",
        answer: "Yes, pickups can be arranged from Pune Airport, Railway Station, hotels, offices, and residential locations."
    },
    {
        question: "How can I book a 14 Seater Tempo Traveller on Rent?",
        answer: "Bookings can be confirmed through phone calls, WhatsApp messages, website inquiries, or online booking forms with Rising Cab Service."
    }
];

const testimonials = [
    {
        id: 1,
        name: "Mr. Vikram Deshpande",
        feedback:
            "We hired a 14 Seater Tempo Traveller for our Mahabaleshwar family trip. The vehicle was spacious, comfortable, and perfect for our group travel requirements.",
        rating: 5
    },
    {
        id: 2,
        name: "Mrs. Poonam Shinde",
        feedback:
            "The Tempo Traveller was clean, well-maintained, and ideal for our pilgrimage tour. Everyone traveled comfortably, and the overall experience was excellent.",
        rating: 5
    }
];





    const Images = [
        { place: "/images/keyword/1.jpg", text: "Pune Darshan Cab", link: "Pune-Darshan-Cab" },
        { place: "/images/keyword/2.jpg", text: "Pune to Bhimashankar Cab", link: "Pune-to-Bhimashankar-Cab" },
        { place: "/images/keyword/3.jpg", text: "Pimpri Chinchwad to Bhimashankar Cab", link: "Pimpri-Chinchwad-to-Bhimashankar-Cab" },
        { place: "/images/keyword/4.jpg", text: "Pune to Jejuri Cab", link: "Pune-to-Jejuri-Cab" },
        { place: "/images/keyword/5.jpg", text: "Pune Weekend Tour Packages", link: "Pune-Weekend-Tour-Packages" },
        { place: "/images/keyword/6.jpg", text: "Pune Darshan Packages", link: "Pune-Darshan-Packages" },
        { place: "/images/keyword/7.jpg", text: "Pune Sade Teen Shakti Peeth Bus on Rent", link: "Pune-Sade-Teen-Shakti-Peeth-Bus-on-Rent" },
        { place: "/images/keyword/8.jpg", text: "Pune Darshan Tempo Traveller on Rent", link: "Pune-Darshan-Tempo-Traveller-on-Rent" },
        { place: "/images/keyword/9.jpg", text: "Pune to Mysore Ooty Cab Package", link: "Pune-to-Mysore-Ooty-Cab-Package" },
        { place: "/images/keyword/10.jpg", text: "Pune to Mumbai Darshan Package", link: "Pune-to-Mumbai-Darshan-Package" },
        { place: "/images/keyword/11.jpg", text: "Pune to Ajanta Ellora Cab Service", link: "Pune-to-Ajanta-Ellora-Cab-Service" },
        { place: "/images/keyword/12.jpg", text: "Pune to Shirdi Darshan Package", link: "Pune-to-Shirdi-Darshan-Package" },
        { place: "/images/keyword/13.jpg", text: "Pune to Pandharpur Darshan", link: "Pune-to-Pandharpur-Darshan" },
        { place: "/images/keyword/14.jpg", text: "Hinjewadi Cab Service", link: "Hinjewadi-Cab-Service" },
        { place: "/images/keyword/15.jpg", text: "Cab Service in Wakad", link: "Cab-Service-in-Wakad" },
        { place: "/images/keyword/16.jpg", text: "Cab Service in Baner Pune", link: "Cab-Service-in-Baner-Pune" },
        { place: "/images/keyword/17.jpg", text: "Cab Service in Kharadi", link: "Cab-Service-in-Kharadi" },
        { place: "/images/keyword/18.jpg", text: "Cab Service in Hadapsar", link: "Cab-Service-in-Hadapsar" },
        { place: "/images/keyword/19.jpg", text: "Cab Service in Viman Nagar", link: "Cab-Service-in-Viman-Nagar" },
        { place: "/images/keyword/20.jpg", text: "Cab Service in Kothrud", link: "Cab-Service-in-Kothrud" },
        { place: "/images/keyword/21.jpg", text: "Cab Service in Pimpri Chinchwad", link: "Cab-Service-in-Pimpri-Chinchwad" },
        { place: "/images/keyword/22.jpg", text: "Cab Service in Wagholi Pune", link: "Cab-Service-in-Wagholi-Pune" },
        { place: "/images/keyword/23.jpg", text: "Pune to Trimbakeshwar Cab", link: "Pune-to-Trimbakeshwar-Cab" },
        { place: "/images/keyword/24.jpg", text: "Cab Service in Pune", link: "Cab-Service-in-Pune" },
        { place: "/images/keyword/25.jpg", text: "Outstation Taxi Service Pune", link: "Outstation-Taxi-Service-Pune" },
    ];














const productSchema = {
"@context": "https://schema.org",
"@type": "Product",
"name": "14 Seater Tempo Traveller on Rent in Pune",
"image": "https://www.risingcabservice.com/assets/images/14-seater-tempo-traveller-pune.jpg",
"description": "Book 14 Seater Tempo Traveller on Rent in Pune with Rising Cab Service for family trips, corporate travel, weddings, and picnic outings. Comfortable AC minibus with professional driver for safe and smooth journeys.",
"brand": {
"@type": "Brand",
"name": "Rising Cab Service"
},
"aggregateRating": {
"@type": "AggregateRating",
"bestRating": "5",
"worstRating": "1",
"ratingValue": "4.8",
"ratingCount": "5471"
},
"offers": {
"@type": "Offer",
"priceCurrency": "INR",
"price": "Starting From ₹22/Km",
"availability": "https://schema.org/InStock",
"url": "https://www.risingcabservice.com/14-seater-tempo-traveller-on-rent-pune"
}
};





    return (
        <div>

<Helmet>
  <title>14 Seater Tempo Traveller on Rent in Pune | Group Travel Cab | +91 9272511548</title>

<meta
 name="description"
 content="Book 14 Seater Tempo Traveller on Rent in Pune for family trips, corporate travel, weddings, and picnics. Comfortable AC minibus with driver for safe group travel."
/>

<meta
 name="keywords"
 content="14 seater tempo traveller on rent, 14 seater bus on rent in pune, 14 seater tempo traveller pimpri chinchwad, 14 seater mini bus rental pune, 13 seater bus hire in pune, 14 seater bus rental in pune, 14 seater tempo traveller for corporate, hire 14 seater minibus for picnic"
/>

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>

</Helmet>

            <div
                className="breadcumb-wrapper"
                style={{
                    backgroundImage: "url('./img/bg/breadcrumb-bg.jpg')",
                    position: "relative",
                }}
            >
                <div
                    style={{
                        position: "absolute",
                        inset: 0,
                        backgroundColor: "rgba(0,0,0,0.3)",
                        zIndex: 1,
                    }}></div>

                <div className="container" style={{ position: "relative", zIndex: 2 }}>
                    <div className="breadcumb-content">
                        <h1 className="breadcumb-title"> {cardData.keyword}</h1>
                    </div>
                </div>
            </div>




















            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/70.jpg' alt='img' className='img-fluid' />
                            <h3 className="py-1"
                                style={{
                                    color: '#FF681A', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >Rising Cab Service: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="topPlaces">

                                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard borderr" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>

                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>


                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div key={index} className="service-row">
                                        {/* <div className="service-icon">
                      🚗
                    </div> */}
                                        <div>
                                            <h4 className="service-title">{service.name}</h4>
                                            <p className="service-desc">{service.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>


                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section" className="why-choose-section">


                                {/* Section Title */}
                                <h2 className="section-title text-white">
                                    Why Choose <span>Rising Cab Service</span>
                                </h2>


                                {/* Cards */}
                                <div className="cards-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div key={index} className="why-card">
                                            <div className="icon-circle">{index + 1}</div>
                                            <h4 className="card-heading">{item.WhyChooseheading}</h4>
                                            <p className="card-desc">{item.WhyChoosedescription}</p>
                                        </div>
                                    ))}
                                </div>
                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Rising Cab Service </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title="Frequently Asked"
                                                    subtitle="Help & Info"
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase keyword={cardData.keyword} />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-telephone-fill"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+919272511548" className="pc-call">+91 9272511548</a>
                                        </div>

                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/919272511548"
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp"></i> WhatsApp
                                            </a>
                                            <a href="tel:+919272511548" className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-envelope-fill"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@risingcabservice.com" className="pc-email">
                                            booking@risingcabservice.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-geo-alt-fill"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Rising Cab Service</strong><br />

                                            A Unit of Atithya Dining LLP,
                                            901, 902 Deron Height, Baner Rd,
                                            Above Ranka Jewelers, Pune,
                                            Maharashtra -411069
                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Onefourseatertempotraveller;